import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["endSlot", "flush", "middleSlot", "responsive", "startSlot"];
import { AbstractToolbar } from '../AbstractToolbar/AbstractToolbar';
import { jsx as _jsx } from "react/jsx-runtime";
export const FilterBar = _ref => {
  let {
      endSlot,
      flush = false,
      middleSlot,
      responsive = true,
      startSlot
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AbstractToolbar, Object.assign({
    backgroundColor: "fill-transparent-default",
    endSlot: endSlot,
    middleSlot: middleSlot,
    responsive: responsive,
    startSlot: startSlot,
    marginBlock: flush ? '0' : '500'
  }, rest));
};